import React from 'react';

export default ({ className, width = '1em', height = '1em' }) => (
  <svg viewBox="0 0 80 100" width={width} height={height} className={className}>
    <path d="M0 0v100l80-50z" fill="currentColor" fillRule="nonzero" />
  </svg>
);
